<template>
  <nav id="navbar" class="navbar" :class="`navbar--${isLoggedIn ? 'logged-in' : 'not-logged-in'}`" @click="dismissProfileSubmenu">
    <div v-if="isMobile" class="mobile" :class="`mobile--${isLoggedIn ? 'logged-in' : 'not-logged-in'}`">
      <Slide class="vue-burger-menu" :closeOnNavigation="true">
        <ul class="nav-list nav-list--mobile">
          <li class="nav-list-item nav-list-item--mobile"><router-link :to="{name: 'home'}" class="navbar-link navbar-link--mobile navbar-link--home">Home</router-link></li>
          <li v-if="!isLoggedIn" class="nav-list-item nav-list-item--mobile">
            <router-link :to="{name: 'login'}" class="navbar-link navbar-link--mobile navbar-link--login">Login</router-link>
          </li>
          <li v-if="!isLoggedIn" class="nav-list-item nav-list-item--mobile">
            <router-link :to="{name: 'register'}" class="navbar-link navbar-link--mobile navbar-link--register">Register</router-link>
          </li>
          <li v-if="isLoggedIn" class="nav-list-item nav-list-item--mobile">
            <router-link :to="{name: 'dashboard'}" class="navbar-link navbar-link--mobile navbar-link--dashboard">Dashboard</router-link>
          </li>
          <li v-if="isLoggedIn && userCanViewAdminStuff" class="nav-list-item nav-list-item--mobile">
            <router-link :to="{name: 'boards'}" class="navbar-link navbar-link--mobile navbar-link--boards">Boards</router-link>
          </li>
          <li class="nav-list-item nav-list-item--mobile">
            <router-link :to="{name: 'categories'}" class="navbar-link navbar-link--mobile navbar-link--categories">Categories</router-link>
          </li>
        </ul>
      </Slide>

      <router-link to="/" class="home-link home-link--mobile" :class="`home-link--${isLoggedIn ? 'logged-in' : 'not-logged-in'}`">
        <Logo
          v-if="isLoggedIn"
          class="logo logo--mobile logo--logged-in"
          :doRandomColorAnimation="getCurrentCategoryColor ? false : true"
          :color="getCurrentCategoryColor ? getCurrentCategoryColor : globalRandomColor"
          :showIcon="showLogoIconLoggedIn"
          :showName="true"
        />
        <Logo v-else class="logo logo--mobile logo--not-logged-in" :doRandomColorAnimation="true" :color="globalRandomColor" :showIcon="true" :showName="showLogoName" />
      </router-link>
      <Logo
        class="logo logo--mobile logo--name-only"
        :class="`logo--${showLogoNameOnItsOwn ? 'show' : 'hide'}`"
        :doRandomColorAnimation="getCurrentCategoryColor ? false : true"
        :color="getCurrentCategoryColor ? getCurrentCategoryColor : globalRandomColor"
        :showIcon="false"
        :showName="true"
      />

      <div v-if="isLoggedIn" class="mobile__profile">
        <a href="#" aria-haspopup="true" class="link__avatar" v-click-outside="dismissProfileSubmenu" @click.stop="onToggleProfileSubmenu">
          <Avatar class="avatar" />
          <span class="sr-only">Profile</span>
        </a>
        <ul v-if="showingProfileSubmenu" class="dropdown" aria-label="submenu" @click.prevent="onSubMenuClick">
          <li v-if="isLoggedIn" class="nav-list-item nav-list-item--mobile">
            <router-link :to="{name: 'profile'}" class="navbar-link navbar-link--view-profile">Your profile</router-link>
          </li>
          <li v-if="isLoggedIn" class="nav-list-item nav-list-item--mobile">
            <router-link :to="{name: 'account'}" class="navbar-link navbar-link--view-account">Account</router-link>
          </li>
          <li v-if="isLoggedIn" class="nav-list-item nav-list-item--mobile" @click="logout"><a href="#" class="navbar-link navbar-link--logout">Logout</a></li>
        </ul>
      </div>
      <div v-else>
        <router-link :to="{name: 'login'}" class="navbar-link navbar-link--mobile navbar-link--btn navbar-link--login">Login</router-link>
        <router-link :to="{name: 'register'}" class="navbar-link navbar-link--mobile navbar-link--btn navbar-link--register">Register</router-link>
      </div>
    </div>
    <div v-if="isDesktop" class="desktop" :class="`desktop--${isLoggedIn ? 'logged-in' : 'not-logged-in'}`">
      <router-link to="/" class="home-link home-link--desktop">
        <Logo
          class="logo logo--desktop"
          :doRandomColorAnimation="getCurrentCategoryColor ? false : true"
          :color="getCurrentCategoryColor ? getCurrentCategoryColor : ''"
          :showIcon="true"
          :showName="true"
        />
      </router-link>
      <ul class="nav-list nav-list--desktop">
        <li v-if="!isLoggedIn" class="nav-list-item nav-list-item--desktop">
          <router-link :to="{name: 'home'}" class="navbar-link navbar-link--desktop navbar-link--home">Home</router-link>
        </li>
        <li v-if="!isLoggedIn" class="nav-list-item nav-list-item--desktop">
          <router-link :to="{name: 'login'}" class="navbar-link navbar-link--desktop navbar-link--login">Login</router-link>
        </li>
        <li v-if="!isLoggedIn" class="nav-list-item nav-list-item--desktop">
          <router-link :to="{name: 'register'}" class="navbar-link navbar-link--desktop navbar-link--register">Register</router-link>
        </li>
        <li v-if="isLoggedIn" class="nav-list-item nav-list-item--desktop">
          <router-link :to="{name: 'dashboard'}" class="navbar-link navbar-link--desktop navbar-link--dashboard">Dashboard</router-link>
        </li>
        <li v-if="isLoggedIn && userCanViewAdminStuff" class="nav-list-item nav-list-item--desktop">
          <router-link :to="{name: 'boards'}" class="navbar-link navbar-link--desktop navbar-link--boards">Boards</router-link>
        </li>
        <li class="nav-list-item nav-list-item--desktop">
          <router-link :to="{name: 'categories'}" class="navbar-link navbar-link--desktop navbar-link--categories">Categories</router-link>
        </li>
        <li v-if="isLoggedIn" class="nav-list-item  nav-list-item--desktop nav-list-item--profile">
          <a href="#" aria-haspopup="true" class="link__avatar" v-click-outside="dismissProfileSubmenu" @click.stop="onToggleProfileSubmenu">
            <Avatar class="avatar" />
            <span class="sr-only">Profile</span>
          </a>
          <ul v-if="showingProfileSubmenu" class="dropdown" aria-label="submenu" @click.prevent="onSubMenuClick">
            <li v-if="isLoggedIn">
              <router-link :to="{name: 'profile'}" class="navbar-link navbar-link--desktop navbar-link--view-profile">Your profile</router-link>
            </li>
            <li v-if="isLoggedIn">
              <router-link :to="{name: 'account'}" class="navbar-link navbar-link--desktop navbar-link--view-account">Account</router-link>
            </li>
            <li v-if="isLoggedIn" @click="logout"><a href="#" class="navbar-link navbar-link--desktop navbar-link--logout">Logout</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import {mapGetters, createNamespacedHelpers} from 'vuex';
import firebase from 'firebase/app';
import ClickOutside from 'vue-click-outside';
import find from 'lodash/find';
import {Slide} from 'vue-burger-menu';
import db from './../firebaseInit.js';
import logUserActivity from './../helpers/logUserActivity';
import updateUserDataInFirebase from './../helpers/updateUserDataInFirebase';
import {LOGGED_OUT} from './../constants/activityLogs';
import Avatar from './Avatar';
import Logo from './Logo';
import isIOS from './../helpers/isIOS';
import isSafari from './../helpers/isSafari';
import {MOBILE_BREAKPOINTS, DESKTOP_BREAKPOINTS, LOGO_WITHOUT_NAME_BREAKPOINTS, LOGO_WITH_NAME_BREAKPOINTS, CATEGORIES} from './../constants/globalConstants';

const userVuexModule = createNamespacedHelpers('userVuexModule');

export default {
  name: 'Navbar',
  components: {
    Avatar,
    Logo,
    Slide,
  },
  props: {
    globalRandomColor: String,
    showLogoNameOnItsOwn: Boolean,
  },
  data: function() {
    return {
      currentCategoryColor: '',
      isLoggedIn: false,
      currentUser: null,
      showingProfileSubmenu: false,
    };
  },
  computed: {
    ...userVuexModule.mapGetters(['userCanViewAdminStuff', 'getPrefersColorScheme', 'getPrefersColorSchemeTemp']),
    ...mapGetters(['getCurrentCategory', 'getCurrentCategoryColor']),
    categories: function() {
      return CATEGORIES;
    },
    isMobile: function() {
      return MOBILE_BREAKPOINTS.includes(this.$mq);
    },
    isDesktop: function() {
      return DESKTOP_BREAKPOINTS.includes(this.$mq);
    },
    showLogoName: function() {
      return LOGO_WITH_NAME_BREAKPOINTS.includes(this.$mq);
    },
    showLogoIconLoggedIn: function() {
      return LOGO_WITH_NAME_BREAKPOINTS.includes(this.$mq);
    },
  },
  created() {
    if (firebase.auth().currentUser && firebase.auth().currentUser.emailVerified) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;
    }
  },
  mounted() {
    this.popupItem = this.$el;
  },
  methods: {
    logout: function() {
      this.$store.dispatch('userVuexModule/SET_LAST_LOGGED_OUT_AT_ACTION');
      this.$store.dispatch('userVuexModule/CLEAR_USER_DATA_ACTION');
      localStorage.removeItem('overrideOsDarkMode');
      localStorage.removeItem('prefersColorScheme');
      logUserActivity(LOGGED_OUT, () => {
        updateUserDataInFirebase(
          {
            numTimesLoggedOut: firebase.firestore.FieldValue.increment(1),
          },
          () => {
            firebase
              .auth()
              .signOut()
              .then(() => {
                this.$router.go({name: 'login'});
                if (isIOS || isSafari) {
                  location.reload();
                }
              })
              .catch(err => {
                console.log(err);
              });
          }
        );
      });
    },
    onToggleProfileSubmenu: function() {
      this.showingProfileSubmenu = !this.showingProfileSubmenu;
    },
    onSubMenuClick: function() {
      this.showingProfileSubmenu = false;
    },
    dismissProfileSubmenu: function() {
      this.showingProfileSubmenu = false;
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss" scoped>
.mobile,
.desktop {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: var(--max-width-site);
  min-height: var(--min-header-height);
  padding: var(--padding-s) var(--padding-m);
  position: relative;
}

.mobile {
  .logo {
    &--name-only {
      left: 50%;
      pointer-events: none;
      position: absolute;
      top: 10rem;
      transform: translateX(-50%);
      width: 22rem;

      &.logo--show {
        visibility: visible;
      }

      &.logo--hide {
        visibility: hidden;
      }
    }
  }

  .navbar-link--btn {
    border: 1px solid var(--text-color);
    border-radius: var(--border-radius);
    text-align: center;

    &.navbar-link--login {
      body.login &,
      body.page-not-found & {
        display: none;
      }
    }
    &.navbar-link--register {
      body.register &,
      body.home &,
      body.page-not-found &,
      body.home &,
      body.forgotten-password & {
        display: none;
      }
    }
  }
}

.mobile__profile {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  padding: 0;
  position: relative;
  text-decoration: none;
  transition-duration: 0.5s;
  z-index: 0;
}

/* .logo {
  &--mobile {
    width: 1rem;
    height: 1rem;
  }
} */

.home-link {
  display: block;
  flex-shrink: 0;
  line-height: 1;
  margin: 0;
  width: 19.8rem;
  padding: 0;

  &--mobile {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);

    &.home-link--logged-in {
      width: 17rem;

      @include breakpoint($mq-sm-md) {
        width: 22rem;
      }
    }

    &.home-link--not-logged-in {
      width: 4rem;

      @include breakpoint($mq-sm-md) {
        width: 22rem;
      }
    }
  }

  &--desktop {
    width: 22rem;
  }
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;

  &--mobile {
    flex-direction: column;

    .navbar-link {
      padding: 2rem 2rem;
      text-align: center;
      width: 30rem;

      &.router-link-active {
        border-bottom: 0;
        font-weight: 700;

        &.navbar-link--home {
          font-weight: 300;
        }
      }

      &.router-link-exact-active {
        &.navbar-link--home {
          border-bottom: 0;
          font-weight: 700;
        }
      }
    }
  }

  a {
    &.router-link-active {
      border-bottom: 1px solid var(--color-header-text);

      &:hover {
        border-bottom-color: var(--color-header-text-hover);
      }

      &.navbar-link--home {
        border-bottom: 0;
      }
    }

    &.router-link-exact-active {
      &.navbar-link--home {
        border-bottom: 1px solid var(--color-header-text);
      }
    }
  }
}

a {
  color: inherit;
  display: block;
  line-height: 1;
  margin: 0;
  padding: 0.5rem 1rem;
  text-decoration: none;

  &:hover {
    color: var(--color-header-text-hover);
  }

  &.link__avatar {
    padding: 0;
  }

  &.navbar-link {
    &--desktop {
      border-bottom: 1px solid transparent;
      padding-left: 0;
      padding-right: 0;
    }
  }
}

ul {
  list-style: none;
  margin: 0;
  padding-left: 0;
}

li {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  padding: 0;
  position: relative;
  text-decoration: none;
  transition-duration: 0.5s;

  &.nav-list-item {
    &--desktop {
      margin-right: 2rem;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.dropdown {
  align-items: flex-end;
  background-color: var(--color-header-background);
  border-radius: 1.5rem;
  border: 1px solid var(--color-navbar-subnav-border);
  /* display: none; */
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  min-width: 12rem;
  /* opacity: 0; */
  padding: 1.5rem;
  position: absolute;
  right: -0.5rem;
  top: calc(100% - 0.5rem);
  transition: all 0.5s ease;
  /* visibility: hidden; */
  /* border: 10px solid red; */

  &::after,
  &::before {
    bottom: 100%;
    left: calc(100% - 3.3rem);
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &::after {
    border-bottom-color: var(--color-header-background);
    border-width: 10px;
    margin-left: 0;
  }

  &::before {
    border-bottom-color: var(--color-navbar-subnav-border);
    border-width: 11px;
    margin-left: -1px;
  }

  li {
    margin-bottom: 3rem;

    @include breakpoint($mq-lg) {
      margin-bottom: 2rem;
    }

    @include breakpoint($mq-lg-xlg) {
      margin-bottom: 1rem;
    }

    &:last-child {
      margin-bottom: 0;
    }

    a {
      margin: 0;
      padding: 0;
      text-align: right;
    }
  }
}

.avatar {
  width: 3.5rem;
  height: 3.5rem;
}

.vue-burger-menu {
  z-index: 1;

  &::before {
    background-color: var(--color-mobile-menu-overlay-bg);
    bottom: 0;
    content: '';
    display: block;
    height: 100vh;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    transition: opacity 0.4s linear;
    width: 100vw;

    body.bm-overlay & {
      opacity: 1;
      pointer-events: all;
    }
  }
}
</style>

<style lang="scss">
.bm-overlay {
  background: var(--bg-color) !important;
}

.vue-burger-menu {
  .bm-burger-button {
    height: 1.6rem !important;
    left: 2rem !important;
    top: 2.5rem !important;
    width: 2.2rem !important;

    .bm-burger-bars {
      background-color: var(--text-color) !important;

      &.line-style {
        height: 10% !important;

        &:nth-child(1) {
          top: 0% !important;
        }
        &:nth-child(2) {
          top: 45% !important;
        }
        &:nth-child(3) {
          top: 90% !important;
        }
      }
    }
  }

  .bm-menu {
    background-color: var(--color-mobile-menu-bg) !important;
    border-right: 1px solid var(--color-header-border-bottom) !important;
    padding-top: var(--min-header-height) !important;
    transform: translateX(-1px) !important;
    width: 0 !important;

    body.bm-overlay & {
      width: 30rem !important;
    }
  }

  .bm-cross {
    background: var(--color-mobile-close-x) !important;
  }

  .bm-item-list {
    box-sizing: border-box !important;
    color: var(--text-color) !important;
    margin-left: 0 !important;

    > * > span {
      color: var(--color-mobile-menu-text) !important;
    }
  }

  .cross-style {
    right: 0.2rem !important;
    top: 2.4rem !important;
  }
}
</style>
